import logger from '../utils/rbata.logger';
import personalizeService from '../services/rbata.personalizeService';

const cartCounter = {
    $cartCounter: undefined,
    init() {
        this.$cartCounter = $('.header__nav-inner > .nav-utility .js-badge-pill');
        this.initCounter();
    },
    initCounter() {
        personalizeService.getPersonalizedData().then((data) => {
            if (data.hasCart) {
                this.updateCounter(data.totalUnitCount);
            }
        }, (jqXHR) => {
            logger.error(`error in cartCounter, code: ${jqXHR.status}`);
        });
    },
    updateCounter(value) {
        this.$cartCounter.text(value);
    }
};

(() => {
    if ($('#page-header').length) {
        cartCounter.init();
    }
})();

export default cartCounter;
